<template>
  <transition name="edit-fade" mode="out-in">
    <div class="columns staff-wrapper" v-if="!edit && !add" :key="'1'">
      <div class="column is-8 staff">
        <div class="field filter">
          <p class="control has-icons-right">
            <input class="input" type="text" :placeholder="$resx('Global.Filter')" v-model="input">
            <span class="icon is-small is-right" @click.prevent="input = ''">
              <font-awesome-icon :icon="icons.delete" />
            </span>
          </p>
        </div>
        <draggable class="staff-list items-list" :tag="'ul'" @start="drag = true" @end="drag = false" :disabled="input !== ''" v-model="allStaff" v-bind="dragOptions">
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <li v-for="(person, idx_l) in filtered" :key="idx_l+1" @click="selectPerson(idx_l)" :class="{selected: selected === idx_l}">
              <div class="image">
                <img class="is-rounded" :src="$store.state.imgBase + person.AvatarUrl" />
              </div>
              <div class="name">
                {{ person.Name }} -
                <small>{{ person.Function }} </small>
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth" @click.prevent="addPerson">
            <span class="icon">
              <font-awesome-icon :icon="icons.add"/>
            </span>
            <span>{{ $resx("Buttons.Add") }}</span>
          </button>
          <button class="button is-fullwidth" :disabled="(selected > -1 ? false : 'disabled')" @click.prevent="edit = true, $emit('canClose', false), $store.commit('contentChanged', true)">
            <span class="icon">
              <font-awesome-icon :icon="icons.edit" />
            </span>
            <span>{{ $resx("Buttons.Edit") }}</span>
          </button>
          <button class="button is-fullwidth is-danger" :disabled="(selected > -1 ? false : 'disabled')" @click.prevent="deletePerson">
            <span class="icon">
              <font-awesome-icon :icon="icons.delete" />
            </span>
            <span>{{ $resx("Buttons.Delete") }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns form-wrapper" v-else :key="'2'">
      <loader :loading="loading" :fixed="false"></loader>
      <form class="column is-8">
        <div class="field">
          <label class="label">{{ $resx("Staff.Name") }}</label>
          <div class="control">
            <input class="input" type="text" ref="personName" v-bind:value="staticPerson.Name" v-on:input="staticPerson.Name = $event.target.value" />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Staff.Email") }}</label>
          <div class="control">
            <input class="input" type="text" ref="personEmail" v-bind:value="staticPerson.Emailaddress" v-on:input="staticPerson.Emailaddress = $event.target.value" />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Staff.Function") }}</label>
          <div class="control">
            <input class="input" type="text" ref="personFunction" v-bind:value="staticPerson.Function" v-on:input="staticPerson.Function = $event.target.value" />
          </div>
        </div>
        <file-input :profile="'avatar'" v-if="staticPerson.AvatarUrl || staticPerson.AvatarUrl === ''" :value.sync="staticPerson.AvatarUrl" @complete="setImage" :disabledProfiles="['meta', 'inline', 'fullwidth', 'image', 'icon', 'header', 'partner', 'theme']"></file-input>
      </form>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth is-success" @click.prevent="submitPerson('submit')" :disabled="(submitEnabled ? false : 'disabled')">
            <span>{{ $resx("Buttons.Save") }}</span>
          </button>
          <button class="button is-fullwidth" @click.prevent="submitPerson('cancel')">
            <span>{{ $resx("Buttons.Cancel") }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import fileInput from '@/components/admin/FileInput.vue'
import { faToggleOn, faToggleOff, faPlus, faPencil, faTimes, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import draggable from 'vuedraggable'
import { getFilenameFromUrl } from '@/mixins/getFilenameFromUrl.js'
import { confirm } from '@/mixins/confirm.js'
import loader from '@/components/Loader.vue'

export default {
  name: 'modalContentStaff',
  data () {
    return {
      loading: false,
      selected: -1,
      input: '',
      drag: false,
      icons: {
        toggleOn: faToggleOn,
        toggleOff: faToggleOff,
        add: faPlus,
        edit: faPencil,
        delete: faTimes,
        trash: faTrashAlt
      },
      add: false,
      edit: false,
      staticPerson: false,
      availableCultures: ['nl-NL', 'en-GB'],
      selectedForDelete: [],
      templates: {
        Person: {
          ID: false,
          Name: '',
          Emailaddress: '',
          Function: '',
          AvatarUrl: ''
        }
      }
    }
  },
  mixins: [confirm, getFilenameFromUrl],
  components: {
    draggable,
    loader,
    fileInput
  },
  computed: {
    allStaff: {
      get () {
        return this.$store.state.staff
      },
      set (value) {
        // update person orders PUT orderArr
        var self = this
        self.$store.commit('setStaff', value)
        var orderArr = []
        value.forEach(person => {
          orderArr.push(person.ID)
        })
        // PUT person order
        self.$http({
          method: 'PUT',
          url: '/staff/order',
          name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
          api: 'website',
          data: orderArr
        }).then(function () {}).catch(function (err) {
          self.$store.dispatch('setSnack', {
            message: err.message
          })
        })
      }
    },
    submitEnabled () {
      if (this.add) {
        return this.staticPerson.Name !== ''
      } else {
        return this.staticPerson.Name !== '' && !(JSON.stringify(this.staticPerson) === JSON.stringify(this.filtered[this.selected]))
      }
    },
    selectedPerson () {
      if (this.selected > -1) { return this.filtered[this.selected] } else { return false }
    },
    filtered () {
      var filtered = []; var self = this; var input = self.input.toLowerCase()
      self.$store.state.staff.forEach(person => {
        if (person.Name.toLowerCase().indexOf(input) > -1 || person.Function.toLowerCase().indexOf(input) > -1) {
          filtered.push(person)
        }
      })
      self.unselectPerson()
      return filtered
    },
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    unselectPerson: function () {
      this.selected = -1
    },
    setImage: function (data) {
      var self = this
      self.staticPerson.AvatarUrl = data.url
    },
    selectPerson: function (idx) {
      if (this.selected === idx) {
        this.selected = -1
        this.staticPerson = false
      } else {
        this.selected = idx
        this.staticPerson = JSON.parse(JSON.stringify(this.filtered[this.selected]))
      }
    },
    addPerson: function () {
      this.staticPerson = this.templates.Person
      this.add = true
      this.$emit('canClose', false)
      this.$store.commit('contentChanged', true)
    },
    deleteImage: function (canceled) {
      var self = this; var newObj; var oldObj
      if (canceled) {
        oldObj = self.staticPerson
        newObj = self.filtered[self.selected]
      } else {
        oldObj = self.filtered[self.selected]
        newObj = self.staticPerson
      }
      if (oldObj && newObj && self.submitEnabled && oldObj.AvatarUrl !== '' && newObj.AvatarUrl !== oldObj.AvatarUrl) {
        var file = self.getFilenameFromUrl(oldObj.AvatarUrl)
        self.$store.dispatch('deleteFile', file)
      }
    },
    deletePerson: function () {
      var self = this; var message
      if (self.selected > -1) {
        message = self.$resx('Global.AreYouSure')
        self.confirm({
          message: message,
          buttons: [
            {
              name: self.$resx('Buttons.Cancel'),
              class: 'is-pulled-left'
            },
            {
              name: self.$resx('Buttons.Delete'),
              class: 'is-pulled-right is-danger',
              action: function () {
                var person = self.filtered[self.selected].ID
                self.loading = true
                self.$http({
                  method: 'DELETE',
                  url: '/staff/' + person,
                  name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                  api: 'website'
                }).then(function (response) {
                  self.loading = false
                  self.$store.dispatch('getSitemap', true).then(function () {
                    self.$store.dispatch('setSnack', {
                      message: self.$resx('Staff.Removed')
                    })
                    self.selected = -1
                  })
                }).catch(function (err) {
                  self.loading = false
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  self.selected = -1
                })
              }
            }
          ]
        })
      }
    },
    resetSelected: function () {
      var self = this
      self.staticPerson = false
      self.selected = -1
      self.add = false
      self.edit = false
      self.$emit('canClose', true)
      self.$store.commit('contentChanged', false)
    },
    submitPerson: function (action) {
      var self = this
      if (action === 'submit') {
        var method = 'PUT'
        if (self.add) {
          method = 'POST'
          delete self.staticPerson.ID
        }
        // save header
        self.loading = true
        self.$http({
          method: method,
          url: '/staff',
          api: 'website',
          data: self.staticPerson,
          name: process.env.VUE_APP_NAME + '_' + self.$store.state.language
        }).then(function (response) {
          self.deleteImage(false)
          self.$store.dispatch('getSitemap', true).then(function () {
            self.$store.dispatch('setSnack', {
              message: self.$resx('Staff.Saved')
            })
            self.loading = false
            self.resetSelected()
          })
        }).catch(function (err) {
          self.$store.dispatch('setSnack', {
            message: err.message
          })
          self.loading = false
          self.resetSelected()
        })
      } else {
        self.deleteImage(true)
        self.loading = false
        self.resetSelected()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.edit-fade-enter-active,
.edit-fade-leave-active,
.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.2s;
}
.edit-fade-enter,
.edit-fade-leave-to,
.tab-fade-enter,
.tab-fade-leave-to {
  opacity: 0;
}
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.3;
}

.staff-wrapper{
  height: 450px;

  .staff{
    .filter{
      display: inline-block;
      vertical-align: top;
      width: 100%;
      margin-right: 10px;
      margin-bottom: 0;

      .control{
        .icon{
          pointer-events: all;
          cursor: pointer !important;
        }
      }
    }

    .staff-list{
      // height: 380px;
      // overflow: auto;
      // margin-top: 10px;

      li{
        height: 50px;
        line-height: 30px;
        // display: inline-block;
        // width: 100%;
        // &.group{
        //   pointer-events: none;
        //   height: 20px;
        //   font-size: 0.9em;
        // }
        // &:not(.group){
        //   height: 50px;
        //   border: 1px solid $grey-lighter;
        //   background-color: $grey-bg;
        //   border-radius: 4px;
        //   padding: 10px 20px;
        //   line-height: 30px;
        //   cursor: pointer;

        //   + li{
        //     margin-top: 10px;
        //   }

        //   &.selected{
        //     border-color: $grey;
        //   }
          .image{
            display: inline-block;
            vertical-align: top;
            width: 40px;
            height: 40px;
            margin-top: -5px;
            margin-right: 10px;

            img{
              height: 100%;
            }
          }
          .name{
            display: inline-block;
            vertical-align: top;
            width: calc(100% - 50px);
            @include text-overflow;

            small{
              opacity: 0.6;;
            }
          }
        // }
      }
    }
  }
}
.form-wrapper{
  >.is-8{
    height: 450px;
    overflow: auto;

    .input-div{
      display: block;
      flex: 1;
      cursor: pointer;
      -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      background-color: #fcfdfd;
      border-radius: 4px 0px 0px 4px;
      align-items: center;
      border: 1px solid #dbdbdb;
      height: 2.25em;
      justify-content: flex-start;
      line-height: 1.5;
      padding-bottom: calc(0.375em - 1px);
      padding-left: 2.25em;
      padding-right: calc(0.625em - 1px);
      padding-top: calc(0.375em - 1px);
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      input{
        position: absolute;
        left: 0;
        opacity: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        cursor: pointer;
      }
    }
  }

  .field{
    &.cultures{
      .radio{
        + .radio{
          margin-left: 15px;
        }
        .icon{
          margin: 0px 5px -7px 5px;
          vertical-align: unset;
        }
      }
    }
  }
}
</style>
